import { useEffect, useRef } from "react";

export default function Cursor() {
  const dot = useRef(null);
  const ring = useRef(null);

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return;
    document.body.classList.add("cursor-luxe");
    const d = dot.current;
    const r = ring.current;
    let rx = 0, ry = 0, x = 0, y = 0;

    const move = (e) => {
      x = e.clientX; y = e.clientY;
      d.style.left = x + "px"; d.style.top = y + "px";
    };
    const raf = () => {
      rx += (x - rx) * 0.18; ry += (y - ry) * 0.18;
      r.style.left = rx + "px"; r.style.top = ry + "px";
      frame = requestAnimationFrame(raf);
    };
    let frame = requestAnimationFrame(raf);

    const over = (e) => {
      if (e.target.closest("a, button, [data-cursor], input, textarea, select, [role='button']")) {
        d.classList.add("hovering"); r.classList.add("hovering");
      }
    };
    const out = (e) => {
      if (e.target.closest("a, button, [data-cursor], input, textarea, select, [role='button']")) {
        d.classList.remove("hovering"); r.classList.remove("hovering");
      }
    };
    window.addEventListener("mousemove", move);
    document.addEventListener("mouseover", over);
    document.addEventListener("mouseout", out);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("mousemove", move);
      document.removeEventListener("mouseover", over);
      document.removeEventListener("mouseout", out);
      document.body.classList.remove("cursor-luxe");
    };
  }, []);

  return (
    <>
      <div ref={ring} className="lux-ring hidden md:block" aria-hidden />
      <div ref={dot} className="lux-cursor hidden md:block" aria-hidden />
    </>
  );
}
